import React, { useContext } from 'react'
import { View } from 'oio-react'
import PropTypes from 'prop-types'
import ProtoThemeContext from 'src/libraries/contexts/ProtoTheme'

const NoteHeaderContainer = ({ children, minHeight }) => {
   const { protoTheme: theme } = useContext(ProtoThemeContext)

   return (
      <View
         display="flex"
         justifyContent="center"
         alignItems="flex-start"
         width="100%"
         paddingVertical={theme.tmpSpacingTop}
         paddingHorizontal={theme.tmpNotePadding}>
         <View width="100%" maxWidth={theme.tmpNoteMaxWidth}>
            {children}
         </View>
      </View>
   )
}

NoteHeaderContainer.propTypes = {
   children: PropTypes.node.isRequired,
   minHeight: PropTypes.string
}

NoteHeaderContainer.defaultProps = {
   minHeight: '15vh'
}

export default NoteHeaderContainer
